import DepartmentStock from "components/DepartmentStock"
import NotFooterLayout from "layouts/NotFooterLayout"

function DepartmentStockPage() {
  return (
    <NotFooterLayout namePage="คลังสต็อกแผนก">
      <div className="layout-content">
        <DepartmentStock />
      </div>
    </NotFooterLayout>
  )
}

export default DepartmentStockPage
